__turbopack_context__.v({
  "SBodyText": "E1CfCG_SBodyText",
  "SBodyTextContainer": "E1CfCG_SBodyTextContainer",
});
